import React from 'react';
import Translation from "@Translation/components/Translation";
import Link from "@Generic/navigation/Link";
import {useTranslation} from "@Translation/hooks/useTranslation";
import Button from "@Generic/buttons/Button";
import useIsMobile from "@Hooks/selector/useIsMobile";
import {useInput} from "@Hooks/dispatch/useInput";
import {useToggle} from "@Hooks/dispatch/useToggle";
import ParamsType from "@SearchResults/types/params/Params.type";
import SearchResultsUrlsType from "@SearchResults/types/urls/SearchResultsUrls.type";
import GenericCheckbox from "@Generic/form/GenericCheckbox";
import useCollectEmailForUpdates from "@SearchResults/features/noResults/hooks/useCollectEmailForUpdates";

function CollectEmail({params, urls}: { params: ParamsType, urls: SearchResultsUrlsType }) {
    const {
        general_terms: generalTerms,
        privacy_policy: privacyPolicy,
    } = urls

    const {
        enter_email: enterEmailLabel,
    } = useTranslation("no_res")

    const terms = useToggle()
    const email = useInput('')

    const {submitEmail} = useCollectEmailForUpdates({params, urls, email, terms})

    const isMobile = useIsMobile()

    return (
        <div className="collect-email">
            <input
                className="gb--input-standalone collect-email__email-input"
                type="email"
                placeholder={enterEmailLabel}
                value={email.value}
                onChange={email.onChange}
            />
            <Button
                className="green"
                additionalClasses={isMobile ? 'btn--mobile' : 'btn--inline'}
                onClick={submitEmail}
            >
                <Translation translationKey="no_res.send"/>
            </Button>
            <div className="toc-info-section confirmation">
                <div className="toc-info">
                    <div className="wrapper">
                        <p className="confirmation-box confirmation__terms">
                            <GenericCheckbox
                                id="gbb-tos-and-privacy-policy"
                                name="gbb_tos_and_privacy_policy"
                                checked={terms.value}
                                onClick={terms.onChange}
                            />
                            <label htmlFor="gbb-tos-and-privacy-policy">
                                <span style={{color: "#9C9C9C"}} id="tos_text">
                                    <Translation translationKey="t_summary.read_and_agreed_to_the"/>
                                    {" "}
                                    <Link href={generalTerms}>
                                        <Translation translationKey="t_summary.terms_&_conditions"/>
                                    </Link>
                                    {" "}
                                    <Translation translationKey="sys.and"/>
                                    {" "}
                                    <Link href={privacyPolicy}>
                                        <Translation translationKey="menu.footer.privacy_policy"/>
                                    </Link>
                                </span>
                            </label>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CollectEmail;